import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { clearUserInfo, clearCaptainData } from '../store/userSlice';

function Navigation() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const isAuthLoading = useSelector((state) => state.user.isAuthLoading);
    const isAdmin = userInfo?.userRoles?.includes('admin');
    const dispatch = useDispatch();
    const handleLogout = () => {
        dispatch(clearUserInfo());
        dispatch(clearCaptainData());
    };

    return (
        <nav className="top-nav">
            <button
                className={`hamburger-menu ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                aria-label="Toggle navigation"
            >
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
                <span className="hamburger-line"></span>
            </button>
            <div className={`nav-menu-horizontal ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <Link to="/" className="nav-menu-item" onClick={() => setIsMobileMenuOpen(false)}>
                    Home
                </Link>

                {userInfo && (
                    <Link to="/guests" className="nav-menu-item" onClick={() => setIsMobileMenuOpen(false)}>
                        My Guests
                    </Link>
                )}

                <Link to="/faq" className="nav-menu-item secondary" onClick={() => setIsMobileMenuOpen(false)}>
                    FAQs
                </Link>

                {isAdmin && (
                    <Link to="/admin" className="nav-menu-item secondary" onClick={() => setIsMobileMenuOpen(false)}>
                        Admin
                    </Link>
                )}

                {isAuthLoading ? (
                    <div className="nav-menu-item secondary" style={{ opacity: 0.5, cursor: 'default' }}>...</div>
                ) : userInfo ? (
                    <a href="/.auth/logout" className="nav-menu-item secondary" onClick={(e) => { handleLogout(); setIsMobileMenuOpen(false); }}>
                        Logout
                    </a>
                ) : (
                    <Link to="/login" className="nav-menu-item secondary" onClick={() => setIsMobileMenuOpen(false)}>
                        Login
                    </Link>
                )}
            </div>
        </nav>
    );
}

export default Navigation;
